import { HelmetDexteel } from "@dexteel/mesf-core";
import { StraightenerKpisReport } from "./components/StraightenerKpisReport";

export const StraightenerKpisPage = () => (
	<>
		<HelmetDexteel title="Straightener KPIs" />
		<StraightenerKpisReport />
	</>
);
